import { Component } from "@angular/core"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-modal-coverage-error",
	templateUrl: "./modal-coverage-error.component.html",
	styleUrls: ["./modal-coverage-error.component.scss"]
})
export class ModalCoverageErrorComponent {
	warningPath = environment.path_imgs_markers + "/warning.png"
}
